
    import { defineComponent, ref } from 'vue';
    import AgentOutput from './AgentOutput';
    import AgentItem from './AgentItem';
    export default defineComponent({
        components: {
        },
        directives: {
        },
        filters: {
        },
        props: {
            agentMessage: {
                required: true,
            },
            agentMessages: {
                required: true,
            },
            areaFilter: {
                required: true,
            },
            locationFilter: {
                required: true,
            }
        },
        data: () => ({
            agentMenu: false,
            items: ref([]),
            message: ref(""),
            thinking: false,
            filterEnabled: false
        }),
        computed: {
        },
        watch: {
            agentMessage(next: AgentOutput | null) {
                if (next == null) return;
                this.updateChat(Object.assign(new AgentOutput(), next), false);
            },
            agentMessages(next) {
                this.setChatHistory(next);
            },
            areaFilter() {
                this.filterEnabled = this.filterButtonEnabled();
            },
            locationFilter() {
                this.filterEnabled = this.filterButtonEnabled();
            },
            agentMenu(next) {
                if (next) {
                    this.scrollToBotom();
                }
            }
        },
        methods: {
            onSend() {
                if (this.thinking || this.message == "") return;
                this.thinking = true;
                this.$store.dispatch('main/agentChat', this.message);
                this.updateChat(new AgentOutput(this.message), true);
                this.message = "";
            },

            updateChat(data: AgentOutput, isUser: boolean, scroll: boolean = true) {
                if (!isUser) this.thinking = false;
                this.items.push(new AgentItem(data, isUser, this.getFilterText(data)));
                if (scroll) {
                    this.scrollToBotom();
                }
            },

            scrollToBotom() {
                setTimeout(() => {
                    if (this.$refs.agentChat) {
                        this.$refs.agentChat.scrollTop = this.$refs.agentChat.scrollHeight;
                    }
                }, 100);
            },

            setChatHistory(agentOutputs) {
                this.items.length = 0;
                this.items.push(new AgentItem(new AgentOutput(this.$t("message.agentIntro")), false));
                agentOutputs.forEach(agentOutput => this.updateChat(new AgentOutput(agentOutput.message), !agentOutput.isAgent, false));
                this.scrollToBotom();
            },

            filterButtonEnabled() {
                return this.areaFilter != null || (this.locationFilter != null && this.locationFilter.length > 0);
            },

            removeFilter() {
                this.$store.dispatch('main/agentRemoveFilters');
                this.items.push(new AgentItem(new AgentOutput(""), false, this.$t("message.agentRemoveFilter")));
                this.scrollToBotom();
            },

            getFilterText(data: AgentOutput) {
                if (data.locationIds.length > 0 && data.selectedAreas.length > 0) {
                    if (data.locationIds.length > 1 && data.selectedAreas.length > 1) {
                        return this.$t("message.agentFilterAreasLocations");
                    }
                    if (data.locationIds.length > 1) {
                        return this.$t("message.agentFilterAreaLocations");
                    }
                    if (data.selectedAreas.length > 1) {
                        return this.$t("message.agentFilterAreasLocation");
                    }
                    return this.$t("message.agentFilterAreaLocation");
                } else if (data.locationIds.length > 0) {
                    if (data.locationIds.length > 1) {
                        return this.$t("message.agentFilterLocations");
                    }
                    return this.$t("message.agentFilterLocation");
                } else if (data.selectedAreas.length > 0) {
                    const totalAreas = data.totalAreas();
                    if (totalAreas > 1) {
                        return this.$t("message.agentFilterAreas");
                    }
                    return this.$t("message.agentFilterArea");
                }
                return null;
            }
        },
    });
